import { getConfig } from './get-config';

declare global {
  interface Window {
    _uxa?: any[];
    uxa?: (...args: any[]) => void;
  }
}

export const loadContentsquare = (): Promise<void> => {
  return new Promise((resolve) => {
    const scriptUrl = getConfig('REACT_APP_CONTENTSQUARE_SCRIPT_URL');
    const enabled = getConfig('REACT_APP_CONTENTSQUARE_ENABLED');

    if (enabled !== 'true' && enabled !== true) {
      resolve();
      return;
    }

    if (
      window._uxa ||
      document.querySelector('script[src*="contentsquare.net"]')
    ) {
      resolve();
      return;
    }

    if (!scriptUrl) {
      console.warn('[Contentsquare] Script URL não configurada');
      resolve();
      return;
    }

    try {
      window._uxa = window._uxa || [];

      const script = document.createElement('script');
      script.async = true;
      script.src = scriptUrl;
      script.onload = () => {
        let attempts = 0;
        const maxAttempts = 50;
        const checkContentsquare = () => {
          attempts++;
          if (window.uxa || window._uxa) {
            resolve();
          } else if (attempts < maxAttempts) {
            setTimeout(checkContentsquare, 100);
          } else {
            console.warn('[Contentsquare] Timeout aguardando inicialização');
            resolve();
          }
        };
        checkContentsquare();
      };
      script.onerror = (error) => {
        console.error('[Contentsquare] Erro ao carregar script:', error);
        resolve();
      };

      document.head.appendChild(script);
    } catch (error) {
      console.warn('[Contentsquare] Erro ao inicializar:', error);
      resolve();
    }
  });
};

export const isContentsquareAvailable = (): boolean => {
  return typeof window !== 'undefined' && (!!window.uxa || !!window._uxa);
};

export const callContentsquare = (method: string, ...args: any[]): void => {
  if (!isContentsquareAvailable()) return;

  try {
    if (window._uxa && Array.isArray(window._uxa)) {
      window._uxa.push([method, ...args]);
    } else if (window.uxa) {
      window.uxa(method, ...args);
    }
  } catch (error) {
    console.error(`[Contentsquare] Erro ao chamar ${method}:`, error);
  }
};

export const setContentsquareProperty = (key: string, value: string): void => {
  callContentsquare('set', key, value);
};

export const trackContentsquareEvent = (
  eventName: string,
  properties?: Record<string, any>,
): void => {
  if (properties) {
    callContentsquare('track', eventName, properties);
  } else {
    callContentsquare('track', eventName);
  }
};
